import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getProblems(patientId, params) {
        return Axios.get(`${baseURL}record/problem/${patientId}`, {
            params
        }).then(response => response.data.response);
    },
    getProblem(patientId, problemId) {
        return Axios.get(
            `${baseURL}record/problem/${patientId}/${problemId}`
        ).then(response => response.data.response);
    },
    saveProblem(patientId, params) {
        return Axios.post(`${baseURL}record/problem/${patientId}`, params).then(
            response => response.data.response
        );
    },
    updateProblem(problemId, params) {
        return Axios.put(`${baseURL}record/problem/${problemId}`, params).then(
            response => response.data.response
        );
    },
    deleteProblem(problemId) {
        return Axios.delete(`${baseURL}record/problem/${problemId}`).then(
            response => response.data.response
        );
    }
};
